import { Empty, Select } from 'antd';

import React from 'react';

const RemoveReservationRuleDrawerContent = ({
  rules = [],
  selectedRuleIds = [],
  onSelectedRuleIdsChange,
  selectedCount = 0,
  entityNoun = 'toys',
}) => {
  if (!rules?.length) {
    return (
      <Empty
        image={Empty?.PRESENTED_IMAGE_SIMPLE}
        description={`The selected ${entityNoun} have no reservation rules to remove.`}
      />
    );
  }

  return (
    <>
      <div className="font-size-14 mb-16">
        Removing from <strong>{selectedCount}</strong> selected {entityNoun}.
      </div>

      <div className="font-size-14 mb-8">Select rules to remove</div>

      <Select
        mode="multiple"
        className="full-width"
        showSearch
        allowClear
        optionFilterProp="label"
        dropdownMatchSelectWidth={false}
        popupClassName="reservation-rule-dropdown"
        placeholder="Select rules"
        value={selectedRuleIds}
        onChange={onSelectedRuleIdsChange}
        options={rules?.map((rule) => ({ value: rule?.id, label: rule?.name }))}
      />
    </>
  );
};

export default RemoveReservationRuleDrawerContent;
